import {Form} from 'antd';
import React, {useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../constants/Common';
import {APITypeEnum} from '../../../../services/interface/tableAPIType';
import supplyChainAPI from '../../../../services/modules/IP/supplyChainAPI';
import frequencyJSON from '../../../../services/modules/JSON/frequency';
import modeOfTransportJSON from '../../../../services/modules/JSON/modeOfTransport';
import supplierInfo from '../../../../services/modules/OM/supplierInfoDetails';
import {upstreamKey} from '../../../Forms/Constants/IP/UpstreamKeyLabel';
import UpstreamForm from '../../../Forms/UpstreamForm';
import Loader from '../../../Loader/Loader';
import {IComponentProps} from '../../Common/perquisiteMaster';

const UpStreamTransportBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const initialValues = {
    facility: record?.facility,
    year: record?.year
  };
  const [suppliers, setSuppliers] = useState([]);

  useEffect(() => {
    Promise.all([
      record?.referenceRecordId &&
        supplyChainAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
      supplierInfo(
        APITypeEnum.GET_ALL,
        undefined,
        `${record?.facility}/${record?.year}/upstream`
      ),
      frequencyJSON(),
      modeOfTransportJSON()
    ])
      .then(([res1, responseSuppliers]) => {
        setSuppliers(
          responseSuppliers?.map((item: any) => {
            return {
              label: item?.[upstreamKey.SUPPLIER_NAME],
              value: item._id,
              data: item?.data
            };
          }) ?? []
        );

        if (res1?.data?.isDeleted === false) {
          caForm.setFieldsValue(res1?.data);
          onValuesChange(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <UpstreamForm
        setSubmitDisabled={() => {}}
        suppliers={suppliers}
        setFormFacility={() => {}}
        setFormSelectedYear={() => {}}
        type="down"
        defaultDisplayStep={true}
      />
      <Form.Item name={'type'} hidden={true} initialValue={'upstream'} />
    </Form>
  );
};

export default UpStreamTransportBills;
